export default {
    install(app) {
        app.directive('draggable', {
            beforeMount(el, binding) {
                if (Object.keys(binding.modifiers).length === 0) {
                    throw new Error('Group must be specified');
                }
                const dragStart = ev => {
                    ev.dataTransfer.effectAllowed = 'all';
                    ev.dataTransfer.setData('data', JSON.stringify(binding.value));
                    ev.dataTransfer.setData(
                        'group',
                        JSON.stringify(Object.keys(binding.modifiers))
                    );
                };
                el.setAttribute('draggable', true);
                el.addEventListener('dragstart', dragStart);
                el._dragStart = dragStart;
            },
            updated(el, { value, modifiers }) {
                el.removeEventListener('dragstart', el._dragStart);
                if (Object.keys(modifiers).length === 0) {
                    throw new Error('Group must be specified');
                }
                const dragStart = ev => {
                    ev.dataTransfer.effectAllowed = 'all';
                    ev.dataTransfer.setData('data', JSON.stringify(value));
                    ev.dataTransfer.setData('group', JSON.stringify(Object.keys(modifiers)));
                };
                el.setAttribute('draggable', true);
                el.addEventListener('dragstart', dragStart);
                el._dragStart = dragStart;
            },
            unmounted(el) {
                el.setAttribute('draggable', false);
                el.removeEventListener('dragstart', el._dragStart);
            }
        });

        app.directive('droppable', {
            beforeMount(el, binding) {
                const drop = ev => {
                    if (ev.preventDefault) ev.preventDefault();
                    if (ev.stopPropagation) ev.stopPropagation();
                    const vData = ev.dataTransfer.getData('data');
                    const vGroup = ev.dataTransfer.getData('group');
                    const myGroup = JSON.parse(vGroup);
                    let imIn = false;
                    if (binding.modifiers.length === 0) {
                        imIn = true;
                    } else {
                        imIn = myGroup.find(element => {
                            return binding.modifiers[element];
                        });
                    }
                    if (imIn) {
                        binding.value.call(el, vData);
                        ev.target.classList.remove('dragover');
                    } else {
                        ev.target.classList.remove('dragover');
                    }
                };
                const dragOver = ev => {
                    if (ev.preventDefault) ev.preventDefault();
                    ev.target.classList.add('dragover');
                };
                const dragLeave = ev => {
                    if (ev.preventDefault) ev.preventDefault();
                    ev.target.classList.remove('dragover');
                };
                el.addEventListener('drop', drop);
                el.addEventListener('dragover', dragOver);
                el.addEventListener('dragenter', dragOver);
                el.addEventListener('dragleave', dragLeave);
            },
            unmounted(el) {
                el.setAttribute('draggable', false);
                el.removeEventListener('dragstart', {});
            }
        });

        app.directive('dragenter', {
            beforeMount(el, binding) {
                const dragEnter = ev => {
                    if (ev.preventDefault) ev.preventDefault();
                    if (ev.stopPropagation) ev.stopPropagation();
                    ev.target.classList.add('dragover');
                    binding.value.call(el);
                };
                el.addEventListener('dragenter', dragEnter);
            },
            unmounted(el) {
                el.removeEventListener('dragenter', {});
            }
        });

        app.directive('dragleave', {
            beforeMount(el, binding) {
                const dragLeave = ev => {
                    if (ev.preventDefault) ev.preventDefault();
                    if (ev.stopPropagation) ev.stopPropagation();
                    binding.value.call(el);
                };
                el.addEventListener('dragleave', dragLeave);
            },
            unmounted(el) {
                el.removeEventListener('dragleave', {});
            }
        });
    }
};
